<template>
  <div>
    <alert ref="alert"></alert>
    <template v-if="!showOtpStep">
      <div id="page-content" tabindex="-1">
        <span aria-label="New Reservation Page" aria-live="polite" role="contentinfo"></span>
        <recaptcha-validation 
          role="presentation" 
          ref="recaptcha" 
          :useNewAuthApi="true"
          @recaptchaValid="onRecaptchaValid"
          @recaptchaInvalid="onRecaptchaInvalid"
          >
        </recaptcha-validation>
        <h2 class="public-h5 font-weight-bold mt-5 mb-5"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          {{ siteText.ui.scheduleReservationHeader }}
        </h2>
        <p class="text-h8 font-weight-bold"
        :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          {{ siteText.ui.scheduleReservationSubHeader }}
        </p>
        <p style="color:red;"
        :class="isRTLLanguage ? 'rtl' : 'normal'"
        ><i>{{ siteText.ui.scheduleReservationRequiredText }}</i></p>
        <v-form ref="form" v-model="valid">
        <v-card class="new-reservation-card">
          <v-card-text class="centerContainer">
              <v-text-field
                v-model="firstName"
                :label="siteText.ui.scheduleFirstName"
                :class="{ required: !firstName, 'v-text-field--reverse': isRTLLanguage }"
                filled
                dense
                required
                :rules="[isValidFirstName]"
              ></v-text-field>
              <v-text-field
                v-model="lastName"
                :label="siteText.ui.scheduleLastName"
                :class="{ required: !lastName, 'v-text-field--reverse': isRTLLanguage  }"
                filled
                dense
                required
                :rules="[isValidLastName]"
              ></v-text-field>
              <v-text-field
                v-model="email"
                :label="siteText.ui.scheduleEmailAddress"
                :class="{ required: !email, 'v-text-field--reverse': isRTLLanguage  }"
                filled
                dense
                required
                :rules="[isValidEmail]"
              ></v-text-field>
              <v-text-field
                v-model="emailConfirm"
                :label="siteText.ui.scheduleEmailAddressConfirm"
                :class="{ required: !emailConfirm, 'v-text-field--reverse': isRTLLanguage  }"
                filled
                dense
                required
              ></v-text-field>
              <v-layout v-if="emailMismatch" class="ml-4 mt-n7">
                  <v-flex sm12 class="red--text" style="font-size: 12px"
                  :class="isRTLLanguage ? 'rtl' : 'normal'"
                  >{{
                    siteText.errors.emailNotMatchError
                  }}</v-flex>
                </v-layout>
              <v-text-field
                v-model="phone"
                :label="siteText.ui.schedulePhoneNumber"
                filled
                dense
                maxlength="14"
                @keypress="isNumber($event)"
                @input="formatPhoneNumber"
                :class="{'v-text-field--reverse': isRTLLanguage  }"
              ></v-text-field>
              <span :class="isRTLLanguage ? 'rtl' : 'normal'" class="red--text" style="font-size:12px" v-if="displayInvalidPhoneMessage">{{ siteText.errors.invalid10DigitPhoneError }}</span>
              <p :class="isRTLLanguage ? 'rtl' : 'normal'" class="red--text" style="font-size:14px" v-if="errorMessage" v-html="errorMessage"></p>
          </v-card-text>
        </v-card>
        <p></p>
        <div class="text-left pt-md-4">
          <!-- Desktop Layout -->
          <v-layout row wrap class="hidden-sm-and-down">
          <v-flex md3>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="back()"
            ><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.scheduleBack }}
          </v-btn>
          </v-flex>
          <v-flex md3>
          <v-btn
            class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            :disabled="!valid || emailMismatch || displayInvalidPhoneMessage"
            :aria-disabled="!valid || emailMismatch || displayInvalidPhoneMessage"
            @click="submit()"
          >
            {{ siteText.ui.scheduleSubmit }}
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
          </v-flex>
          </v-layout>
          <!-- Mobile Layout -->
          <v-layout row wrap class="hidden-md-and-up">
            <v-flex xs12>
              <v-btn
              class="ma-2 dmv-btn"
              height="45px"
              width="260px"
              :disabled="!valid || emailMismatch || displayInvalidPhoneMessage"
              :aria-disabled="!valid || emailMismatch || displayInvalidPhoneMessage"
              @click="submit()"
            >
              {{ siteText.ui.scheduleSubmit }}
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-btn
              class="ma-2 dmv-btn"
              height="45px"
              width="260px"
              @click="back()"
              ><v-icon>mdi-arrow-left</v-icon>
              {{ siteText.ui.scheduleBack }}
            </v-btn>
            
            </v-flex>
            </v-layout>
        </div>
        </v-form>
      </div>
    </template>

    <template v-else>
      <OtpVerification ref="otpComponent" @VerifyOtp="onOtpVerified" />
    </template>  
  </div> 
  
</template>

<script>
import Alert from '../components/Alert.vue';
import { mapGetters, mapActions } from 'vuex';
import RecaptchaValidation from '@/components/RecaptchaValidation.vue';
import OtpVerification from './OtpVerification.vue';
import nyApi from '@/api/nyApi';

export default {
  name: 'NewReservationPage',
  components: {
    RecaptchaValidation,
    OtpVerification,
    Alert
  },
  data: () => ({
    showOtpStep: false,
    valid: false,
    firstName: '',
    lastName: '',
    email: '',
    emailConfirm: '',
    phone: '',
    emailMismatch: false,
    errorMessage:'',
  }),
  methods: {
    ...mapActions(['setUserInfo']),
    ...mapActions(['getExistingBookings']),
    ...mapActions(['verifyOtp']),
    ...mapActions(["getLocaleSpecificServiceTypes"]),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      this.$emit('navigateTo', 'WelcomePage');
    },
    submit() {
      //Validate Recaptcha//
      let userDetails = this.getUserDetails();
      this.$refs.recaptcha.verifyRecaptcha(userDetails, this.testSiteCode);
    },
    async onRecaptchaValid({data, isSuccessful}) {

      nyApi.ClearIsMFAEnabled();

      if(this.bookings && this.bookings.length > 0) {
        this.errorMessage = this.buildBookingExistsError((this.bookings[0]), this.siteText.errors.reservationExists2);
        return;
      }

      //Save user data//
      this.setUserInfo({ firstName:this.firstName, lastName:this.lastName, email:this.email, phone:this.phone });

      // navigate to select service page
      if (isSuccessful && !data.isOtpRequired)
        await this.navigateTOSelectServicePage();

      // if otp required is true then show the otp page
      // show otp page
      if (data.isOtpRequired)
      {
        this.showOtpStep = true;
        nyApi.SetIsMFAEnabled("Y");
      }
    },

     async ShowAlert(title, message) {
      return this.$refs.alert.open(title, message);
    },

    async onOtpVerified(otp) {
      // verify the otp here
      const {errorCode, isSuccessful} = await this.verifyOtp({otp: otp});

      if (isSuccessful) {
        this.showOtpStep = false;
        await this.navigateTOSelectServicePage();
      }

      switch (errorCode) {
        case "OtpOrTokenMissing":
          this.$refs.otpComponent.showAlert(this.siteText.errors.otpRequired, this.siteText.errors.otpRequired_Message)
                  .then(()=> {
                    this.$refs.otpComponent.focusOtpField();
                  });
                  break;
        case "OtpInvalidOrExpired":
          this.$refs.otpComponent.showAlert(this.siteText.errors.otpInvalidOrExpired, this.siteText.errors.otpInvalidOrExpiredMessage)
                .then(()=> {
                    this.$refs.otpComponent.focusOtpField();
                  });
                  break;
        case "OtpResendLimitExceeded":
          this.$refs.otpComponent.showAlert(this.siteText.errors.authLimitExceeded, this.siteText.errors.authLimitExceededMessage)
            .then(() => {
              this.$emit('navigateTo', 'WelcomePage');
            });
          break;
        default:
          this.$refs.otpComponent.showAlert(this.siteText.errors.AUTH_UNEXPECTED_ERROR, this.siteText.errors.otpVerificationUnexpectedErrorMessage)
            .then(()=> {
                    this.$refs.otpComponent.focusOtpField();
                  });
      }

    },

    async navigateTOSelectServicePage() {
      await this.getLanguageSpecificServiceTypes();
      this.$emit('navigateTo', 'SelectServicePage', { 
          pageName:'Select Service for Reservation'
        });
    },
    onRecaptchaInvalid({errorCode}) {
      
      this.errorMessage = this.siteText.errors.recaptchaError,
      this.displayErrorMessage = true;

      if (errorCode) {
         switch (errorCode) {
            case "ValidationFailed":
              return this.ShowAlert(this.siteText.errors.authMissingDetails, this.siteText.errors.authMissingDetailsMessage);
            case "AccessDenied":
              return this.ShowAlert(this.siteText.errors.authAccessDenied, this.siteText.errors.authAccessDeniedMessage);
            case "OtpSendFailed":
              return this.ShowAlert(this.siteText.errors.authOTPFailed, this.siteText.errors.authOTPFailedMessage);
            case "ReCaptchaFailed":
              return this.ShowAlert(this.siteText.errors.loginValidationFailed, this.siteText.errors.loginValidationFailedRecaptcha);
            default:
              return this.ShowAlert(this.siteText.errors.AUTH_UNEXPECTED_ERROR, this.siteText.errors.AUTH_UNEXPECTED_ERROR_MESSAGE);
          }
      }
    },
    buildBookingExistsError(booking, msg) {
      const bookingDateTime = '<span class="ltr-text-force">' + booking.FormattedBookingDateTime + '</span>'
      let errorMessage =  msg.replace("E_MAIL", this.email).replace("SITE_NAME", booking.SiteName).replace("BOOKING_DATE", bookingDateTime);
      const serviceType1 = this.$store.getters.serviceType(booking.ServiceTypeId);
      errorMessage = errorMessage.replace("SERVICE_1", serviceType1.Name);
      if(booking.ServiceType2 != null) {
        const serviceType2 = this.$store.getters.serviceType(booking.ServiceTypeId2);
        errorMessage = errorMessage.replace("SERVICE_2", serviceType2.Name);
      } else {
        errorMessage = errorMessage.replace("and SERVICE_2","");
      }
      return errorMessage
    },
    isNumber(e) {
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        // Number
        return true;
      }
      return e.preventDefault();
    },
    isValidFirstName(value) {
      if (!value || value.includes('  ')) {
        return this.siteText.errors.firstNameRequiredError;
      }
      const firstChar = value[0];
      if (firstChar === ' ') {
        return this.siteText.errors.firstNameRequiredError;
      }
      return true;
    },
    isValidLastName(value) {
      if (!value || value.includes('  ')) {
        return this.siteText.errors.lastNameRequiredError;
      }
      const firstChar = value[0];
      if (firstChar === ' ') {
        return this.siteText.errors.lastNameRequiredError;
      }
      return true;
    },
    isValidEmail(value) {
      if (!value) {
        return this.siteText.errors.emailRequiredError;
      }
      // eslint-disable-next-line no-useless-escape
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(value)) {
        return this.siteText.errors.invalidFormatEmailError2;
      }
      return true;
    },
    isValidPhone(value) {
      if (!value) {
        return this.siteText.errors.phoneNumberRequiredError;
      }
      if (value.length !== 14) {
        return this.siteText.errors.invalidPhoneError;
      }
      return true;
    },
    formatPhoneNumber() {
      const x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      // eslint-disable-next-line prefer-template
      this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    getUserDetails(){
      return {
        FirstName: this.firstName,
        LastName: this.lastName,
        Email: this.email,
        PhoneNumber: this.phone
      }
    },
    async getLanguageSpecificServiceTypes() {
      console.log(this.language);
      if (this.language.Code !== "en") {
        await this.getLocaleSpecificServiceTypes();
      }
    },
  },
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['userInfo']),
    ...mapGetters(['navFromSelectServicePage']),
    ...mapGetters(['bookings', 'isRTLLanguage']),
    ...mapGetters(['language']),
    ...mapGetters(['testSiteCode']),
    displayInvalidPhoneMessage() {
      if (!this.phone) {
        return false;
      }
      if (this.phone.length !== 14) {
        return true;
      }
      return false;
    },
    emailAddresses() {
      return this.email + "|" + this.emailConfirm;
    },
  },
  watch: {
    emailAddresses: function () {
      this.emailMismatch =
        this.email.toLowerCase() !== this.emailConfirm.toLowerCase();
    },
  },
  mounted() {
    if (this.navFromSelectServicePage) {
      this.firstName = this.userInfo.firstName;
      this.lastName = this.userInfo.lastName;
      this.email = this.userInfo.email;
      this.emailConfirm = this.userInfo.email;
      this.phone = this.userInfo.phone;
    } 
  },

};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
